import { useQuery } from "react-query";
import axios from "infra/http";
import { UnidadeUnificadaResponse } from "../typings";

function useDetalheUnidadeUnificada(id?: string) {
  return useQuery(
    `/v1/unidades-unificadas/${id}`,
    async () => {
      const { data } = await axios.get<UnidadeUnificadaResponse>(
        `/v1/unidades-unificadas/${id}`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useDetalheUnidadeUnificada;
